import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
              <span className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-base">
                51
              </span>
              <span className="font-heading font-bold text-2xl text-background-50">
                暗网
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-sm mb-6">
              51暗网 — 专业的吃瓜黑料实时追踪平台。每日更新网红塌房、明星黑料、娱乐圈爆料等热门八卦内容，提供最新最全的吃瓜体验。
            </p>
            <div className="flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-video-line', 'ri-bilibili-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-primary-500 hover:bg-primary-500 transition-all cursor-pointer"
                  aria-label="社交媒体"
                  rel="nofollow"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-6">
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-500 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-500 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">下载App</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">投稿爆料</a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-500 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="mailto:hello@chigualiao.cn" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">hello@chigualiao.cn</a>
              <span className="text-sm text-foreground-400">7×24小时在线</span>
              <span className="text-sm text-foreground-400">投稿与合作</span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 51暗网. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}